import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';
import '../../css/CreatePayment.css';
import { DateField,TextField,MessageBox,SelectField,AutocompleteField, IbanField,Checkbox,StepperTable,Icon } from 'component-lib';
import { DateTimeHelper,CheckValues,Jump,CheckFields,CheckEmail } from 'utils-lib';
import { PaymentsModel,CustomerModel, RequestAjaxClass, StreetsModel} from 'models-lib';

var moment = require('moment');
moment().format();

class CreatePayment extends Component
{
    constructor(props){
        super(props);
        this.state = {};

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

        this.state.CustomerText = '';
        this.CustomerId = props.match.params.CustomerId;
        this.NewContract = props.match.params.NewContract;
        this.PaymentsModel = new PaymentsModel([this]);
        this.CustomerModel = new CustomerModel([this]);
        this.StreetsModel = new StreetsModel([this], "StreetsCustomer",this.Request2);
    }

    componentWillMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);

      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);
      
      this.PaymentsModel.SetRequest(this.Request);
      this.CustomerModel.SetRequest(this.Request);
      //this.StreetsModel.SetRequest(this.Request2);
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "StreetsCustomer"){

          let streetSelection = [];
  
          if(this.StreetsModel.Streets.length > 0){
  
            let streetArray = this.StreetsModel.Streets;

            for(let i = 0; i < streetArray.length; i++){
              streetSelection.push({ Key: streetArray[i], Display: streetArray[i] });
            }      
          }
  
          this.setState({StreetValues : streetSelection});
           if(this.refs.streetAddressAccountOwner){
             this.refs.streetAddressAccountOwner.setState({Data:streetSelection});
           }
  
          this.setState({oldZipstreet: this.StreetsModel.PostCode, oldCitystreet: this.StreetsModel.City });
        }
        else if(observer === "Customer"){
          if (this.CustomerModel.Customer.Id !== '')
          {
              let value = this.CustomerModel.Customer;

              me.setState({ CustomerText: <table style={{ textAlign:'initial', marginLeft:'15px' }}>
                <thead>
                  <tr>
                    <th colSpan={2}>
                      <div style={{ float: "left" }}>{Vas.Resources.Labels["PaymentFor"]}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["CustomerNumber"]}:
                    </td>
                    <td>
                      {value.CustomerNumber}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["Name"]}:
                    </td>
                    <td>
                      {value.Name1}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["FirstName"]}:
                    </td>
                    <td>
                      {value.Name2}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {Vas.Resources.Labels["Email"]}:
                    </td>
                    <td>
                      {value.Email}
                    </td>
                  </tr>
                </tbody>
              </table>
            });
          }
        } 
        else if(observer === "Streets"){
          if (me.refs.streetAddressAccountOwner){
            me.refs.streetAddressAccountOwner.setState({ Data: this.StreetsModel.Streets, Icon : '' });
          }
          me.setState({oldZip: this.StreetsModel.PostCode, oldCity: this.StreetsModel.City });
        }
        else if(observer === "CreatePaymentSetDateTo"){
          $("#LoadingIconPopUp").removeClass().addClass('hide');
            
          if (me.NewContract === 'true'){
            Vas.GetView('CreateContract', { CustomerId: me.CustomerId }, true);
          } else {
            Vas.GetView('CreatePaymentSuccess', { CustomerId : me.CustomerId }, true);
          }
        }
        else if(observer === "Customers"){
          if (this.CustomerModel.Customers)
          {         
              this.CustomerModel.Customers.forEach(function(value) {
                me.setState({ CustomerText: <table style={{ textAlign:'initial', marginLeft:'15px' }}>
                  <thead>
                    <tr>
                      <th colSpan={2}>
                        <div style={{ float: "left" }}>{Vas.Resources.Labels["PaymentFor"]}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {Vas.Resources.Labels["CustomerNumber"]}:
                      </td>
                      <td>
                        {value.CustomerNumber}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {Vas.Resources.Labels["Name"]}:
                      </td>
                      <td>
                        {value.Name1}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {Vas.Resources.Labels["FirstName"]}:
                      </td>
                      <td>
                        {value.Name2}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {Vas.Resources.Labels["Email"]}:
                      </td>
                      <td>
                        {value.Email}
                      </td>
                    </tr>
                  </tbody>
                </table>
              });           
            });
          }

          $("#LoadingIcon").removeClass().addClass('hide');
      }
      });
    }

    componentDidMount(){

        //Schließen aller Stepper und öffnen des ersten Steppers
        Jump.jump(2,1);

        if (localStorage.getItem('vas_role') === "3"){
          //this.CustomerModel.GetCustomerById(this.CustomerId);

          this.CustomerModel.GetCustomers(localStorage.getItem("SendData"),null,null,"name1",null,"Abo",null,null,null,null,null,localStorage.getItem("Number_CurrentCustomer"),null,null,null);
        }

        let reqFields = [
          { Key:this.refs.iban,Index:6,Step:1 }, 
          { Key:this.refs.accountOwnerName,Index:1,Step:1 },
          { Key:this.refs.accountOwnerFirstName,Index:2,Step:1 },
          { Key:this.refs.dateOfBirthAccountOwner,Index:4,Step:1 },
          { Key:this.refs.emailAccountOwner,Index:5,Step:1 }, 
          { Key:this.refs.nameOfBank,Index:7,Step:1 }, 
          { Key:this.refs.bic,Index:8,Step:1 },
          { Key:this.refs.zipAddressAccountOwner,Index:11,Step:2 },
          { Key:this.refs.cityAddressAccountOwner,Index:12,Step:2 },
          { Key:this.refs.streetAddressAccountOwner,Index:13,Step:2 },
          { Key:this.refs.houseNumberAddressAccountOwner,Index:14,Step:2 }];
            
        this.setState({ requiredFields:reqFields,
          //requiredSelectField:[{ }],
          requiredCeckBox:[{ Key:this.refs.AcceptPaymentTerms, Index:15, Step: 2 }]
         },()=>{
            for (let i=0; i<this.state.requiredFields.length; i++){
                if (this.state.requiredFields[i].Key.props.IsRequired){
                    this.state.requiredFields[i].Key.setState({ Label:this.state.requiredFields[i].Key.props.Label+"*" });
                }
            }

          //   for (let i = 0; i < this.state.requiredSelectField.length; i++){
          //     if (this.state.requiredSelectField[i].Key.props.IsRequired){
          //         this.state.requiredSelectField[i].Key.setState({ Label:this.state.requiredSelectField[i].Key.props.Label + "*" });
          //     }
          // }
        }); 
    }
    
    createPayment(){

        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
                        
        this.PaymentsModel.PaymentOption.IsDefaultPaymentMethod = true;
        this.PaymentsModel.PaymentOption.PaymentMethodValue = 4;
        this.PaymentsModel.PaymentOption.AccountOwner = this.PaymentsModel.CustomerPaymentOption.Name1 + " " + this.PaymentsModel.CustomerPaymentOption.Name2;
        
        this.PaymentsModel.CustomerId = this.CustomerId;
        this.Request.setErrorHandler((data)=>{
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Title={Vas.Resources.Labels["MethodOfPaymentCustomer"]} 
            Message={data.Description} /> 
                    , document.getElementById('messageContainer'));
            $("#LoadingIconPopUp").removeClass().addClass('hide');
        });
        this.PaymentsModel.CreatePaymentSetDateTo();
    }

    checkIban()
    {
      let me = this;
      this.refs.nameOfBank.setState({ Icon:"Loop" });

      let valid = this.refs.iban.getValid();
      if (valid[0] === true){
        if (valid[1]){
          me.refs.nameOfBank.setState({ Icon:'',Value:valid[1],editable:false });
          me.refs.bic.setState({ Value:valid[2],editable:false });
          this.PaymentsModel.PaymentOption.Iban = $("#iban2").val();
          this.PaymentsModel.PaymentOption.BankName = valid[1];
          this.PaymentsModel.PaymentOption.Bic = valid[2];
        } else {
          $("#nameOfBank").val('');
          $("#bic").val('');
          me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:true });
          me.refs.bic.setState({ Value:null,editable:true });
          this.PaymentsModel.PaymentOption.Iban = $("#iban2").val();
        }
      } else {
        $("#iban2").val('');
        $("#nameOfBank").val('');
        $("#bic").val('');
        me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:false });
        me.refs.bic.setState({ Value:null,editable:false });
      }
    }

    checkFields(){
        let count;
        if (this.state.requiredFields && this.state.requiredCeckBox){
            count = this.state.requiredFields.length + this.state.requiredCeckBox.length;
        
            let filled = 0;
            let first = { Key:'',Index:500,Step:0 };

            for (let i = 0;i < this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].Key.props.Id).value.length > 0){
                      if(!(/^\s+$/).test(document.getElementById(this.state.requiredFields[i].Key.props.Id).value)){
                        filled++;
                      }
                    } else {
                      if (this.state.requiredFields[i].Index < first.Index){
                        first = this.state.requiredFields[i];
                      }
                    }
                }
            }

            
            //let result = CheckFields.CheckSelectFields(this.state.requiredSelectField,first);
            // filled += result[0];
            // first = result[1];
            
            let result = CheckFields.CheckCheckBox(this.state.requiredCeckBox,first);
            filled += result[0];
            first = result[1];
            
            if (filled < count){
              let docs = document.querySelectorAll('select,input');
              let docRefs = this.refs;
              CheckValues.checkAllFields(docs,docRefs,"");
              ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["NotAllFields"]} 
                Title={Vas.Resources.Titles["Note"]}
                />
                  ,document.getElementById('messageContainer'));
               return false;
            } else {
                this.createPayment();
            }
          }
    }

    getStreets() //holt alle Straßen für eine eingegebene PLZ und Ort
    {
        this.refs.streetAddressAccountOwner.setState({ Icon:"Loop" });
        let plz = '';
        let city = '';
        let me = this;
        
        if ((this.PaymentsModel.CustomerPaymentOption.PostCode !== me.state.oldZip)||(this.PaymentsModel.CustomerPaymentOption.City !== me.state.oldCity)){
          me.refs.streetAddressAccountOwner.setState({ Data: [], Icon : '' });
          document.getElementById("streetAddressAccountOwner").value = '';
        }

        if (this.PaymentsModel.CustomerPaymentOption.City || this.PaymentsModel.CustomerPaymentOption.PostCode){ //PLZ und Ort müssen eingegeben sein
          if (this.PaymentsModel.CustomerPaymentOption.City){
            if (this.PaymentsModel.CustomerPaymentOption.City.length > 0 ){
                city = this.PaymentsModel.CustomerPaymentOption.City;
            }
          }
          if (this.PaymentsModel.CustomerPaymentOption.PostCode){
            if (this.PaymentsModel.CustomerPaymentOption.PostCode.length > 0){
              plz = this.PaymentsModel.CustomerPaymentOption.PostCode;
            }
          }
        }
                   
        if (plz.length > 0 || city.length > 0){
            this.StreetsModel.GetStreets(city,plz);
        }
    }

    checkEmail(){
      if ($("#emailAccountOwner").val().length > 0){
        if (CheckEmail.Check($("#emailAccountOwner").val()) === true){
          this.refs.IconEmail.setState({ Name:"Done",Color:"green" });
          this.PaymentsModel.CustomerPaymentOption.Email = $("#emailAccountOwner").val();
        } else {
          this.refs.IconEmail.setState({ Name:"Warning",Color:"red" });
        }
      } else {
        this.refs.IconEmail.setState({ Name:"Warning",Color:"red" });
      }
    }

    //#region Stepper
    setPaymentStep(){
      let min = moment();
      let maxValue = moment([min.year() - 18, min.month(), min.date()]); //minValue für Geburtsdatums Datepicker nicht älter als 18 Jahre

      let paymentValidFrom = (<tr></tr>);

      if(Vas.ShowPaymentValidFrom == true){
        paymentValidFrom = (<tr>
                <td>
                  <div className={"ContainerValidFrom"}>
                    <DateField
                    AppURL={Vas.ApplicationUrl}
                    Language={localStorage.getItem("vas_language")}
                    me={this}
                    Editable={true}
                    ref={"ValidFrom"}
                    IsRequired={false}
                    Id={"ValidFrom"} 
                    Label={Vas.Resources.Labels["ValidFrom"]}
                    OnBlur={()=>{
                      let cur = DateTimeHelper.StringToDate($("#ValidFrom").val(),false,localStorage.getItem('vas_language'));
                      this.PaymentsModel.PaymentOption.ValidFrom = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00') ;}}/>
                  </div>
                </td>
              </tr>);
      }

      return(
        <table>
          <tbody>
            <tr>
              <td>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"accountOwnerName"}
                  Id="accountOwnerName"
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["DepositorName"]} 
                  OnChange={()=>{ this.PaymentsModel.CustomerPaymentOption.Name1 = $("#accountOwnerName").val(); }}
                  Modus={"Name"}/>
                </div>
                <div className={"ContainerRight"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"accountOwnerFirstName"}
                  Id="accountOwnerFirstName"
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["DepositorFirstname"]} 
                  OnChange={()=>{ this.PaymentsModel.CustomerPaymentOption.Name2 = $("#accountOwnerFirstName").val(); }}
                  Modus={"Name"}/>
                </div>
              </div>
              </td>
            </tr>
            <tr>
              <td>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"accountOwnerGender"}
                  IsRequired={false}
                  Id={"accountOwnerGender"}
                  Label={Vas.Resources.Labels["Gender"]}
                  Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] },{ Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]}
                  OnBlur={()=>{ this.PaymentsModel.CustomerPaymentOption.Gender = $("#accountOwnerGender").val();}}
                  Tooltip={Vas.Resources.Tooltips["Gender"]} 
                  SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/>
                </div>
                <div className={"ContainerRight"}>
                  <DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"dateOfBirthAccountOwner"}
                  MaxValue={maxValue}
                  IsRequired={true}
                  Id={"DateOfBirthAccountOwner"} 
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{
                    let cur = DateTimeHelper.StringToDate($("#DateOfBirthAccountOwner").val(),false,localStorage.getItem('vas_language'));
                    this.PaymentsModel.CustomerPaymentOption.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00') ;
                  }}
                  FalseMaxDateText={Vas.Resources.Labels["AccountOwnerDateOfBirthInvalid"]} 
                  FalseMinDateText={Vas.Resources.Labels["AccountOwnerDateOfBirthInvalid"]} />
                </div>
              </div>
              </td>
            </tr>
            <tr>
              <td>
              <div className={"ContainerEmailAccountOwner"}>
                <TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Id="emailAccountOwner" 
                  ref={"emailAccountOwner"} 
                  Editable={true} 
                  IsRequired={true} 
                  Label={Vas.Resources.Labels["Email"]} 
                  OnChange={()=>{this.checkEmail();}} 
                  OnBlur={()=>{if(this.refs.IconEmail.state.Name === "Warning"){
                    $("#emailAccountOwner").val('');
                    ReactDOM.render(
                      <MessageBox 
                        AppURL={Vas.ApplicationUrl} 
                        Title={Vas.Resources.Titles["Note"]} 
                        Message={Vas.Resources.Labels["InvalidEMail"]} /> 
                        , document.getElementById('messageContainer'));
                  }}}
                  Width={324}/>
                <Icon 
                  ref={"IconEmail"} 
                  Name={"Warning"} 
                  Size={24} 
                  Color={"red"}/>
              </div>
              </td>
            </tr>
            <tr>
              <td  colSpan={2}>
              <div className={"ContainerIban"}>
                <IbanField
                ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={317}
                  ref={"iban"}
                  Id="iban2"
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Iban"]}
                  OnBlur={()=>{this.checkIban();}}
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  Token={localStorage.getItem["vas_token"]}
                  AnonymousToken={localStorage.getItem["anonymous_token"]} />
                </div>
              </td>
            </tr>
            <tr>
              <td  colSpan={2}>
              <div className={"ContainerNameOfBank"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"nameOfBank"}
                Width={324}
                Id="nameOfBank"
                Editable={false}
                IsRequired={true}
                Label={Vas.Resources.Labels["NameOfBank"]} 
                Value={this.state.BankName}
                OnBlur={()=>{this.PaymentsModel.PaymentOption.BankName =$('#nameOfBank').val();}} />
              </div>
              </td>
            </tr>
            <tr>
              <td  colSpan={2}>
              <div className={"ContainerBic"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"bic"}
                Width={324}
                Id="bic"
                Editable={false}
                IsRequired={true}
                Label={Vas.Resources.Labels["Bic"]} 
                Value={this.state.BankName}
                OnBlur={()=>{this.PaymentsModel.PaymentOption.Bic = $('#bic').val();}} />
              </div>
              </td>
            </tr>
            { paymentValidFrom }
            <tr>
              <td style={{textAlign:'left'}}>
              <div className={"ContainerLeft"}>
                <br />
                {Vas.Resources.Labels["RequiredField"]}
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      );
    }

    setCustomerStep(){
      return(
        <table>
          <tbody>
            <tr>
              <td>
              <div className={"ContainerLeft"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Id="zipAddressAccountOwner"
                ref={"zipAddressAccountOwner"}
                Editable={true}
                IsRequired={true}
                Tooltip={Vas.Resources.Tooltips["Zip"]}
                Label={Vas.Resources.Labels["Zip"]} 
                OnChange={()=>{ this.PaymentsModel.CustomerPaymentOption.PostCode = $("#zipAddressAccountOwner").val(); }}
                Modus={"Number"} 
                OnBlur={()=>{this.getStreets();}} />
              </div>
              <div className={"ContainerRight"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Id="cityAddressAccountOwner"
                ref={"cityAddressAccountOwner"}
                Editable={true}
                IsRequired={true}
                Tooltip={Vas.Resources.Tooltips["Place"]}
                Label={Vas.Resources.Labels["Place"]} 
                OnChange={()=>{ this.PaymentsModel.CustomerPaymentOption.City = $("#cityAddressAccountOwner").val(); }}
                OnBlur={()=>{this.getStreets();}} />
              </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
              <div className={"ContainerStreetAddressAccountOwner"}>
                <SelectField
                TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                AppURL={Vas.ApplicationUrl}
                me={this}
                Width={348}
                Id="streetAddressAccountOwner" 
                ref={"streetAddressAccountOwner"}
                Modus={"Street"}
                editable={true}
                IsRequired={true}
                Data={this.StreetValues}
                Tooltip={Vas.Resources.Tooltips["Street"]} 
                Label={Vas.Resources.Labels["Street"]}
                OnBlur={()=>{ this.PaymentsModel.CustomerPaymentOption.Street = $("#streetAddressAccountOwner").val(); }}
                TimeOutTime={Vas.TimeOutTime} />
              </div>
              </td>
            </tr>
            <tr>
              <td>
              <div className={"ContainerLeft"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Id="houseNumberAddressAccountOwner"
                ref={"houseNumberAddressAccountOwner"}
                Editable={true}
                IsRequired={true}
                Tooltip={Vas.Resources.Tooltips["Housenumber"]} 
                Label={Vas.Resources.Labels["HouseNumber"]}
                OnChange={()=>{ this.PaymentsModel.CustomerPaymentOption.HouseNumber = $("#houseNumberAddressAccountOwner").val() ; }} />
              </div>
              <div className={"ContainerRight"}>
                <TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Id="houseNumberAdditionAddressAccountOwner"
                ref={"houseNumberAdditionAddressAccountOwner"}
                Editable={true}
                IsRequired={false}
                Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                Label={Vas.Resources.Labels["HouseNumberAddition"]}
                OnChange={()=>{ this.PaymentsModel.CustomerPaymentOption.HouseNumberAddition = $("#houseNumberAdditionAddressAccountOwner").val() ; }} />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
              <div className={"ContainerLeft"}>
                <br/>
                <Checkbox
                  ref={"AcceptPaymentTerms"}
                  Id={"checkboxAcceptPaymentTerms"}
                  onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} />
                  <div style={{ textAlign:'left', width: '351px', marginTop: '-3px' }}>
                    <i style={{ fontSize: '12px' }}>
                      {Vas.Resources.Labels["PaymentText"]}*
                    </i>
                  </div>
              </div>
              </td>
            </tr>
            <tr>
              <td style={{textAlign:'left'}}>
              <div className={"ContainerLeft"}>
                <br />
                {Vas.Resources.Labels["RequiredField"]}
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
    //#endregion
    
    render(){
       
      let payment = StepperTable.buildStepperTable(1,2,Vas.Resources.Labels["MethodOfPaymentCustomer"],this.setPaymentStep(),true);

      let adress = StepperTable.buildStepperTable(2,2,Vas.Resources.Labels["AccountOwnerData"],this.setCustomerStep(),false,true,true,"CreateMethodOfPayment",()=>{
        this.checkFields();
      });



  
    return (
      <div>
        <table
          className={"customerCard createPaymentForm"}
          style={{ width:'500px',display:'inline-block',overflowY:'hidden', overflowX:'hidden' }}>
          <thead>
            <tr>
              <th style={{ float:"right", lineHeight:"30px", paddingRight:"20px", paddingTop:"10px" }}>
                <div id={"LoadingIconPopUp"}></div>
              </th>
            </tr>
            <tr>
              <th>
                <h2>
                  {Vas.Resources.Titles["CreatePayment"]}
                </h2>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{this.state.CustomerText}</td>
            </tr>
            <tr>
              <td>
                {payment}
                {adress}
              </td>
            </tr>
          </tbody>
        </table>      
      </div>
        );
    }
}
export default CreatePayment;
